import { render, staticRenderFns } from "./orderTableSelect.vue?vue&type=template&id=067751d6&scoped=true&"
import script from "./orderTableSelect.vue?vue&type=script&lang=js&"
export * from "./orderTableSelect.vue?vue&type=script&lang=js&"
import style0 from "./orderTableSelect.vue?vue&type=style&index=0&id=067751d6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "067751d6",
  null
  
)

export default component.exports